import { createStore, applyMiddleware } from 'redux'
import rootReducer from '../reducers';
import thunkMiddleware from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension';

import firebase from 'firebase/app'
import firebaseConfig from "../fireBaseConfig"
import 'firebase/auth';

import { addZeroPrefixInString, monthName } from '../constant'

// Initializing Firebase with our credentials
if(!firebase.apps.length){
    firebase.initializeApp(firebaseConfig);
}

const checkAnyHitsOccur = (msg) => {
    console.log('Chk', msg)
}

// This function updating stock data to the respective tabs.
// The payload parameter is an object, which have the stock data in payload and tab name in the arrayname.
export let pushDataToTabs = payload => (dispatch, getState) => {    
    dispatch({ type: 'pushDataToTabs', payload: payload.payload, arrayName: payload.arrayName })
}

export let  setEndDate = payload => (dispatch, getState) => {    
    dispatch({ type: 'setEndDate', payload: payload.payload })
}

export let setStopCalc = payload => (dispatch, getState) => {    
    dispatch({ type: 'setStopCalc', payload: payload.payload })
}

export let deleteOptionSymbol = payload => (dispatch, getState) => {    
    dispatch({ type: 'deleteOptionSymbol', payload: payload.payload, index: payload.index })
}

export let setCloseVerify =  payload => (dispatch, getState) => {    
    dispatch({ type: 'setCloseVerify', payload: payload.payload, arrayName: payload.arrayName, index: payload.index })
}

export function setCurrentExpiryMonth(dispatch) {
    let currentMonth = new Date().getMonth() + 1
    let nextMonth = currentMonth + 1
    let thirdMonth = currentMonth + 2

    dispatch({ type: "setCurrentExpiryMonth", data: [monthName[addZeroPrefixInString(currentMonth)], monthName[addZeroPrefixInString(nextMonth > 12 ? nextMonth - 12 : nextMonth)], monthName[addZeroPrefixInString(thirdMonth > 12 ? thirdMonth - 12 : thirdMonth)]] })
}

// This function will fetch the list of symbols from DB and dispatched to our reducers.
export function fetchSymbols(dispatch) {
    const db = firebase.firestore()
    // let symbolsDocRef = db.collection('symbols').doc('listOfSymbols')
    let symbolsDocRef = db.collection('symbolsNew').doc('listOfSymbols')

    symbolsDocRef.get()
        .then(doc => {
            dispatch({ type: "addSymbols", data: doc.data()['symbols']})
        })
}

// This function will update the user login status in reducers.
export let  userLoginSwitch = payload => (dispatch, getState) => {
    dispatch({ type: 'userLoginSwitch', payload: payload.data })
}

// This function will update loading status in reducers.
export let  handleLoading = payload => (dispatch, getState) => {
    dispatch({ type: 'loading', payload: payload.data })
}

// This function will update the calculated data in DB, it'll called once the calculation is done...
// Params:
// docName - The collection name
// docId - The document ID
// tabDataToUpdate - Data need to be update
export let  updateTabDataInDB = payload => (dispatch, getState) => {
    const db = firebase.firestore()
    let tabDocRef = db.collection(payload.docName).doc(payload.docId)    

    tabDocRef
        .update(payload.tabDataToUpdate)
        .then(_ => {
            dispatch({ type: 'updateTabDataInDB', selectedTabIndex: payload.selectedTabIndex, arrayName: payload.docName, payload: payload.tabDataToUpdate })
        })
}

// This function let us to add new tabs
// We passed the following parameters:
// arryaName - The collection name &
// data - Data, all values set empty while creating new tab. 
export let  addNewTab = payload => (dispatch, getState) => {
    const db = firebase.firestore()
    let docRef = db.collection(payload.arrayName).doc()
    let docId = docRef.id
    let dataObj = payload.data

    docRef = db.collection(payload.arrayName).doc(docId)
    docRef.set(dataObj).then(_ => {
        firebase.auth().onAuthStateChanged( user => {
            if(user) {
                let userDocRef = db.collection('userData').doc(user.uid)
                userDocRef.get().then(doc => {
                    let tabData = doc.data()[payload.arrayName]
                    tabData[tabData.length] = docId

                    userDocRef.update({
                        [payload.arrayName]: tabData
                    })

                    dataObj['docId'] = docId
                    dispatch({ type: 'addNewTab', arrayName: payload.arrayName, data: dataObj, selectedTabName: payload.selectedTabName })
                })
                .catch(err => {
                    console.log(err)
                })
            }
        })
    })
}

// This function let us to delete tabs
// We passed the following parameters:
// arryaName - The collection name
// docId - The document ID
export let handleDeleteTab = payload => (dispatch, getState) => {    
    const db = firebase.firestore() 
    let docRef = db.collection(payload.arrayName).doc(payload.docId)

    docRef.delete().then(_ => {
        // Getting user ID
        firebase.auth().onAuthStateChanged( user => {
            if(user) {
                let userDocRef = db.collection('userData').doc(user.uid)
                userDocRef.get().then(doc => {
                    // Removing the tab details from user document
                    let tabData = doc.data()[payload.arrayName]                    
                    tabData.splice(tabData.indexOf(payload.docId), 1)                    

                    userDocRef.update({
                        [payload.arrayName]: tabData
                    })
                    dispatch({ type: 'deleteTab', tabIndex: payload.tabIndex, arrayName: payload.arrayName, selectedTabName: payload.selectedTabName })
                })
                .catch(err => {
                    console.log(err)
                })
            }
        })
    })
}

// This function will set the screen size respective to the width.
export function screenWidthIsSmall(dispatch, getState) {
    dispatch({ type: 'isSmallScreen', payload: window.innerWidth < 900 })
}

export function loadingWhenAddingTab(dispatch, getState) {
    dispatch({ type: 'loadingWhenAddingTab' })
}

// This will let us to switch the theme (dark or light mode)
// We need to pass true to get dark mode theme & vice versa
export let switchDarkMode = payload => (dispatch, getState) => {    
    dispatch({ type: 'switchDarkMode', payload: payload })
}

// The following functions are used in select form section,
// Required parameter,
// index - Tab number,
// arrayName - Tab name,
// value - Respective values to the fields
export let changeInterval = payload => (dispatch, getState) => {     
    dispatch({ type: 'changeInterval', index: payload.index, arrayName: payload.arrayName, value: payload.value })
}

export let turnOnROffNotification = payload => (dispatch, getState) => {     
    dispatch({ type: 'turnOnROffNotification', index: payload.index, arrayName: payload.arrayName })
}

export let setSymbols = payload => (dispatch, getState) => {
    dispatch({ type: 'setSymbols', data: payload.data })
}

export let pushStockData = payload => (dispatch, getState) => {     
    dispatch({ type: 'pushStockData', data: payload.data, index: payload.index, arrayName: payload.arrayName })
}

export let instrumentChange = payload => (dispatch, getState) => {    
    dispatch({ type: 'instrumentChange', data: payload.data, index: payload.index, arrayName: payload.arrayName })
}

export let expiryChange = payload => (dispatch, getState) => {    
    dispatch({ type: 'expiryChange', data: payload.data, index: payload.index, arrayName: payload.arrayName })
}

export let exchangeChange = payload => (dispatch, getState) => {    
    dispatch({ type: 'exchangeChange', data: payload.data, index: payload.index, arrayName: payload.arrayName })
}

export let changeSwingType = payload => (dispatch, getState) => {
    dispatch({ type: 'changeSwingType', data: payload.data, index: payload.index, arrayName: payload.arrayName })
}

export let setPhase = payload => (dispatch, getState) => {    
    dispatch({ type: 'setPhase', data: payload.data, index: payload.index, arrayName: payload.arrayName })
}

export let removeLastElementInPhaseVale = payload => (dispatch, getState) => {    
    dispatch({ type: 'removeLastElementInPhaseVale', index: payload.index, arrayName: payload.arrayName, phaseName: payload.phaseName })
}

export let setPhaseValuesEmpty =  payload => (dispatch, getState) => {    
    dispatch({ type: 'setPhaseValue', arrayName: payload.arrayName, index: payload.index, phaseName: payload.phaseName })
}

export let updatePhaseValues = payload => (dispatch, getState) => {    
    dispatch({ type: 'updatePhaseValues', data: payload.data, index: payload.index, arrayName: payload.arrayName, phaseName: payload.phaseName })
}

export let changeSymbol = payload => (dispatch, getState) => {
    dispatch({ type: 'changeSymbol', data: payload.data, index: payload.index, arrayName: payload.arrayName })
}

export let changeCaptionName = payload => (dispatch, getState) => {
    dispatch({ type: 'changeCaptionName', data: payload.data, index: payload.index, arrayName: payload.arrayName })
}

export let changeExpiryDate = payload => (dispatch, getState) => {    
    dispatch({ type: 'changeExpiryDate', data: payload.data, index: payload.index, arrayName: payload.arrayName })
}

export let changeEndDate = payload => (dispatch, getState) => {    
    dispatch({ type: 'changeEndDate', data: payload.data, index: payload.index, arrayName: payload.arrayName })
}

export let changeEndTime = payload => (dispatch, getState) => {    
    dispatch({ type: 'changeEndTime', data: payload.data, index: payload.index, arrayName: payload.arrayName })
}

// This will let us to set initial phase data values in all categories
// Required parameter
// data - Calculated data (data type - array),
// index - Tab number,
// arrayName - Tab name
export let updateInitPhaseCalc = payload => (dispatch, getState) => {    
    dispatch({ type: 'initPhaseCalc', payload: payload.data, index: payload.index, arrayName: payload.arrayName })
}

// This will let us to set current phase data values in all categories
// Required parameter
// data - Calculated data (data type - array),
// index - Tab number,
// key - Tab name
export let updateCurrentPhaseCalc = payload => (dispatch, getState) => {    
    dispatch({ type: 'currentPhaseCalc', payload: payload.data, index: payload.index, key: payload.key })
}

export let setCorrectionCandleDetails = payload => (dispatch, getState) => {    
    dispatch({ type: 'setCorrectionCandleDetails', payload: payload.data, index: payload.index, key: payload.key })
}

export let updateInitPhaseCalcPositional = payload => (dispatch, getState) => {
    dispatch({ type: 'updateInitPhaseCalcPositional', payload: payload.data, index: payload.index })
}

export let setCurrentPhaseLoading = payload => (dispatch, getState) => {
    dispatch({ type: "currentPhaseLoading", loading: payload.loading })
}

export let setCurrentPhaseLoadingForTab = payload => (dispatch, getState) => {
    dispatch({ type: "setCurrentPhaseLoadingForTab", categoryName: payload.categoryName, tabIndex: payload.tabIndex, loadingStatus: payload.loadingStatus })
}

// Hide or display element for all, the value will change respective to the current value.
// Required parameter
// index - Tab number,
// elementName - The container name &
// arrayName - Tab name
export let hideOrDisplayElement = payload => (dispatch, getState) => {    
    dispatch({ 
        type: 'hideOrDisplayElement', 
        arrayName: payload.arrayName,
        index: payload.index,
        elementName: payload.elementName 
    })
}

export let changeCurrentPhaseSwing = payload => (dispatch, getState) => {    
    dispatch({ 
        type: 'changeCurrentPhaseSwing', 
        arrayName: payload.arrayName,
        index: payload.index,
        payload: payload.value,
        date: payload.date
    })
}

// Only for display this element
// Required parameter
// index - Tab number,
// elementName - The container name &
// arrayName - Tab name
export let onlyDisplayElement = payload => (dispatch, getState) => {    
    dispatch({ 
        type: 'onlyDisplayElement', 
        arrayName: payload.arrayName,
        index: payload.index,
        elementName: payload.elementName
    })
}

// Switch from one tab to another
// Required parameter
// index - Tab number,
// keyName - Tab name
export let switchTabs = payload => (dispatch, getState) => {    
    dispatch({ type: 'switchTabs', index: payload.index, keyName: payload.keyName })
}

// This will let us to set additional data values in all categories
// Required parameter
// data - Calculated data (data type - array),
// index - Tab number,
// arrayName - Tab name
export let updateOrderPlacementCalc = payload => (dispatch, getState) => {    
    dispatch({ type: 'orderPhaseCalc', payload: payload.data, index: payload.index, arrayName: payload.arrayName })
}

export let updateOrderPlacementCalcPositional = payload => (dispatch, getState) => {    
    dispatch({ type: 'updateOrderPlacementCalcPositional', payload: payload.data, index: payload.index })
}

// This will let us to set additional data values in all categories
// Required parameter
// data - Calculated data (data type - array),
// index - Tab number,
// arrayName - Tab name
export let updateAdditionalDataCalc = payload => (dispatch, getState) => {   
    dispatch({ type: 'additionalDataCalc', payload: payload.data, index: payload.index, arrayName: payload.arrayName })
}

export let updateAdditionalDataCalcPositional = payload => (dispatch, getState) => {   
    dispatch({ type: 'updateAdditionalDataCalcPositional', payload: payload.data, index: payload.index })
}

// This will let us to set swing value for all category
// Required parameter
// data - Which has the swing type,
// index - The tab number,
// swingVal - Swing value &
// arrayName - The tab name
export let setSwing = payload => (dispatch, getState) => {
    dispatch({ type: 'setSwing', payload: payload.data, index: payload.index, swingVal: payload.value, arrayName: payload.arrayName })
}

export let setLatestSwing = payload => (dispatch, getState) => {
    dispatch({ type: 'latestSwing', payload: payload.data, index: payload.index, arrayName: payload.arrayName })
}

// This will let us to set swing value for positional category
export let setSwingPositional = payload => (dispatch, getState) => {    
    dispatch({ type: 'setSwingPositional', payload: payload.data, index: payload.index, swingVal: payload.value })
}

// updateLastCloseValue
export let updateLastCloseValue = payload => (dispatch, getState) => {    
    dispatch({ type: 'updateLastCloseValue', key: payload.key, index: payload.index, value: payload.value })
}

export let updateInitialLastCloseValue = payload => (dispatch, getState) => {    
    dispatch({ type: 'updateInitialLastCloseValue', arrayName: payload.arrayName, selectedTabIndex: payload.selectedTabIndex, data: payload.data })
}

// setCandleData
export let setCandleData = payload => (dispatch, getState) => {    
    dispatch({ type: 'setCandleData', arrayName: payload.arrayName, selectedTabIndex: payload.selectedTabIndex, data: payload.data })
}

export let setHeikenashiClose = payload => (dispatch, getState) => {
    dispatch({ type: 'setHeikenashiClose', value: payload.value, index: payload.index, arrayName: payload.arrayName, selectedTabIndex: payload.selectedTabIndex })
}

export let addNewSymbol = payload => (dispatch) => {
    dispatch({ type: "addNewSymbol", data: payload.data })
}

export let symbolFilter = payload => (dispatch) => {
    dispatch({ type: "symbolFilter", key: payload.key })
}

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunkMiddleware)))

export default store;